import * as fromDatatype from "../../../../models/datatype-library";
export class JobSearchDto {
  server_doc_type?: string;
  client_doc_type?: string;
  guids?: any[];
  guid_trip_hdrs?: any[];
  guid_region_hdrs?: any[];
  label_list_guids?: any[];
  from_branch_guids?: any[];
  to_branch_guids?: any[];
  from_location_guids?: any[];
  to_location_guids?: any[];
  from_logistic_hub_guids?: any[];
  to_logistic_hub_guids?: any[];
  sender_entity_hdr_guids?: any[];
  recipient_entity_hdr_guids?: any[];
  recipient_customer_codes?: any[];
  from_branch_codes?: any[];
  to_branch_codes?: any[];
  from_location_codes?: any[];
  to_location_codes?: any[];
  from_logistic_hub_codes?: any[];
  to_logistic_hub_codes?: any[];
  start_time?: fromDatatype.TimestampTzDatatypeInterface;
  end_time?: fromDatatype.TimestampTzDatatypeInterface;
  sender_pickup_from_datetime_from?: fromDatatype.TimestampTzDatatypeInterface;
  sender_pickup_from_datetime_to?: fromDatatype.TimestampTzDatatypeInterface;
  shipment_types?: any[];
  codes?: any[];
  names?: any[];
  ext_delivery_consignment_no_list?: any[];
  ext_delivery_reference_no_list?: any[];
  ext_delivery_tracking_id_list?: any[];
  ext_delivery_statuses?: any[];
  delivery_statuses?: any[];
  delivery_logics?: any[];
  process_hdr_guids?: any[];
  process_status_guids?: any[];
  process_status_names?: any[];
  process_resolution_guids?: any[];
  process_resolution_codes?: any[];
  running_number_01s?: any[];
  running_number_02s?: any[];
  running_number_03s?: any[];
  logistic_ref_no_1s?: any[];
  logistic_ref_no_2s?: any[];
  logistic_ref_no_3s?: any[];
  logistic_ref_no_4s?: any[];
  logistic_ref_no_5s?: any[];
  duration_minute_list?: any[];
  sender_ref_no_1s?: any[];
  sender_ref_no_2s?: any[];
  sender_ref_no_3s?: any[];
  sender_ref_no_4s?: any[];
  sender_ref_no_5s?: any[];
  sender_supplier_codes?: any[];
  sender_names?: any[];
  sender_emails?: any[];
  sender_phone_no_list?: any[];
  sender_address_1s?: any[];
  sender_address_2s?: any[];
  sender_address_3s?: any[];
  sender_address_4s?: any[];
  sender_address_5s?: any[];
  sender_cities?: any[];
  sender_postcodes?: any[];
  sender_states?: any[];
  sender_countries?: any[];
  sender_customer_codes?: any[];
  recipient_ref_no_1s?: any[];
  recipient_ref_no_2s?: any[];
  recipient_ref_no_3s?: any[];
  recipient_ref_no_4s?: any[];
  recipient_ref_no_5s?: any[];
  recipient_names?: any[];
  recipient_emails?: any[];
  recipient_phone_no_list?: any[];
  recipient_address_1s?: any[];
  recipient_address_2s?: any[];
  recipient_address_3s?: any[];
  recipient_address_4s?: any[];
  recipient_address_5s?: any[];
  recipient_cities?: any[];
  recipient_postcodes?: any[];
  recipient_states?: any[];
  recipient_countries?: any[];
  tracking_ids?: any[];
  calcTotalRecords?: number;
  has_trips?: any[];
  search_keyword?: any[];
}
